import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const AnalyticsPageSubtitleWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
        gap: ${theme.spacing(2)};
        grid-area: subtitle;
        @container (max-width:  ${breakpoints.small.max}px) {
          margin-bottom: ${theme.spacing(1)};
        }
        @container (max-width:  ${breakpoints.xsmall.max}px) {
          flex-direction: column;
        }
      `}
    >
      {children}
    </div>
  );
};
